import { createStyles, makeStyles } from '@mui/styles';
import { ScreenLayoutListProps } from './types';

const useScreenListStyles = makeStyles(({ shape, spacing, palette }) => {
  return createStyles({
    menuItemText: {
      fontSize: '0.9rem',
    },
    screenLayoutWrapper: {
      position: 'relative',
      left: '50%',
      maxWidth: spacing(50),
      maxHeight: '20%',
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: 'rgba(0, 0, 0)',
      borderRadius: shape.borderRadius,
      color: palette.common.white,
      padding: `${spacing(1)} 0`,
      marginBottom: spacing(),
      overflow: 'scroll',
    },
    screenLayoutItem: {
      padding: `${spacing(0.5)} 0`,
    },
    screenMenuItem: {
      '&:hover': {
        backgroundColor: '#303030',
      },
    },
    screenLoading: {
      height: '30px',
      textAlign: 'center',
    },
    loader: {
      width: '30px',
      height: '30px',
    },
    screenListWrapper: {
      maxWidth: spacing(50),
      maxHeight: spacing(50),
      height: (props: ScreenLayoutListProps) =>
        props.cameraHeight && props.controllerHeight
          ? `${props.cameraHeight - (props.controllerHeight + 50)}px`
          : spacing(40),
      overflowY: 'scroll',
      scrollBehavior: 'smooth',
      position: 'relative',
      scrollbarColor: 'auto',
    },
  });
});

export default useScreenListStyles;
